export enum IrbModelsEvents {
    SHOW_EDIT_MODEL = "IRBMODELSEVENTS.SHOW_EDIT_MODEL",
    MODEL_ALLOCATION_REFRESH = "IRBMODELSEVENTS.MODEL_ALLOCATION_REFRESH",
    SHOW_VIEW_SECURITY_MODEL = "IRBMODELSEVENTS.SHOW_VIEW_SECURITY_MODEL",
    SHOW_IMPORT_SECURITY_MODELS = "IRBMODELSEVENTS.SHOW_IMPORT_SECURITY_MODELS",
    IMPORT_SECURITY_MODELS_COMPLETE = "IRBMODELSEVENTS.IMPORT_SECURITY_MODELS_COMPLETE",
    SHOW_IMPORT_SECURITY_MODELS_RESULT ="IRBMODELSEVENTS.SHOW_IMPORT_SECURITY_MODELS_RESULT",
    SHOW_IMPORT_SECURITY_MODELS_UNRECOGNIZED = "IRBMODELSEVENTS.SHOW_IMPORT_SECURITY_MODELS_UNRECOGNIZED",
    SHOW_IMPORT_SECURITY_MODELS_CONTAINS = "IRBMODELSEVENTS.SHOW_IMPORT_SECURITY_MODELS_CONTAINS",
    SHOW_IMPORT_BLENDED_MODELS = "IRBMODELSEVENTS.SHOW_IMPORT_BLENDED_MODELS",
    SHOW_IMPORT_BLENDED_MODELS_ERROR ="IRBMODELSEVENTS.SHOW_IMPORT_BLENDED_MODELS_ERROR",
    SHOW_IMPORT_BLENDED_MODELS_RESULT ="IRBMODELSEVENTS.SHOW_IMPORT_BLENDED_MODELS_RESULT",
    SHOW_CREATE_SECURITY_MODELS = "IRBMODELSEVENTS.SHOW_CREATE_SECURITY_MODELS",
    SHOW_REPLACE_SECURITY_MODELS = "IRBMODELSEVENTS.SHOW_REPLACE_SECURITY_MODELS",
    SHOW_DELETE_MODEL_DIALOG = "IRBMODELSEVENTS.SHOW_DELETE_MODEL_DIALOG",
    SHOW_CREATE_BLENDED_MODELS = "IRBMODELSEVENTS.SHOW_CREATE_BLENDED_MODELS",
    SHOW_CREATE_NEW_SECURITY =  "IRBMODELSEVENTS.SHOW_CREATE_NEW_SECURITY",
    SHOW_EDIT_SECURITY = "IRBMODELSEVENTS.SHOW_EDIT_SECURITY",
    SHOW_EDIT_MULTIPLE_SECURITY_DIALOG = "IRBMODELSEVENTS.SHOW_EDIT_MULTIPLE_SECURITY_DIALOG",
    SHOW_EDIT_MULTIPLE_SECURITIES = "IRBMODELSEVENTS.SHOW_EDIT_MULTIPLE_SECURITIES",
    SHOW_DELETE_SECURITIES_DIALOG = "IRBREBALANCEEVENTS.SHOW_DELETE_SECURITIES_DIALOG",
    SHOW_IMPORT_SECURITY_CATEGORY = "IRBMODELSEVENTS.SHOW_IMPORT_SECURITY_CATEGORY",
    SHOW_IMPORT_EQUIVALENTS = "IRBMODELSEVENTS.SHOW_IMPORT_EQUIVALENTS",
    SHOW_IMPORT_EQUIVALENTS_ERROR ="IRBMODELSEVENTS.SHOW_IMPORT_EQUIVALENTS_ERROR",
    SHOW_IMPORT_SECURITY_CATEGORY_SECURITIES = "IRBMODELSEVENTS.SHOW_IMPORT_SECURITY_CATEGORY_SECURITIES",
    SHOW_IMPORT_SECURITY_CATEGORY_OVERWRITE = "IRBMODELSEVENTS.SHOW_IMPORT_SECURITY_CATEGORY_OVERWRITE",
    SHOW_MASTER_MULTIPLE_SECURITY = "IRBMODELSEVENTS.SHOW_MASTER_MULTIPLE_SECURITY",
    SAVE_MASTER_MULTIPLE_SECURITY = "IRBMODELSEVENTS.SAVE_MASTER_MULTIPLE_SECURITY",
    SAVE_EDIT_SECURITY = "IRBMODELSEVENTS.SAVE_EDIT_SECURITY",
    SHOW_CREATE_SECURITIES = "IRBMODELSEVENTS.SHOW_CREATE_SECURITIES",
    SHOW_DELETE_SECURITIES_ERROR_DIALOG = "IRBREBALANCEEVENTS.SHOW_DELETE_SECURITIES_ERROR_DIALOG",
    SHOW_DELETE_SECURITIES_SYMBOL_DIALOG = "IRBREBALANCEEVENTS.SHOW_DELETE_SECURITIES_SYMBOL_DIALOG",
    SAVE_CREATE_NEW_SECURITY = "IRBMODELSEVENTS.SAVE_CREATE_NEW_SECURITY",
    SHOW_EDIT_MMC_MODEL = "IRBMODELSEVENTS.SHOW_EDIT_MMC_MODEL",
    SHOW_EDIT_FIRM_INFO = "IRBMODELSEVENTS.SHOW_EDIT_FIRM_INFO",
    SHOW_EDIT_MMC_ADVISOR_MODEL = "IRBMODELSEVENTS.SHOW_EDIT_MMC_ADVISOR_MODEL",
    SHOW_MMC_PAID_AGREEMENT = "IRBMODELSEVENTS.SHOW_MMC_PAID_AGREEMENT",
    SHOW_MAN_FEE_AGREEMENT = "IRBMODELSEVENTS.SHOW_MAN_FEE_AGREEMENT",
    SHOW_SUBSCRIBE_NEXT = "IRBMODELSEVENTS.SHOW_SUBSCRIBE_NEXT",
    SHOW_SUBSCRIBE_TRAIN = "IRBMODELSEVENTS.SHOW_SUBSCRIBE_TRAIN",
    SHOW_ADD_TO_EXISTING_BLENDED_MODELS = "SHOW_ADD_TO_EXISTING_BLENDED_MODELS",
    SHOW_IMPORT_TLHWSA_RESULT = "IRBMODELSEVENTS.SHOW_IMPORT_TLHWSA_RESULT",
    SHOW_IMPORT_MMC_MODELS_FINISH = "IRBMODELSEVENTS.SHOW_IMPORT_MMC_MODELS_FINISH",
    SHOW_CREATE_SYNTAX_DIALOG = "IRBMODELSEVENTS.SHOW_CREATE_SYNTAX_DIALOG"
}
